import { useDispatch } from 'react-redux';
import TableComponent from '../../components/table/tableComponent';
import './simulationTable.css';
import { useEffect, useState } from 'react';
import { setChartTitle } from '../../redux/slices/uiSlice';

export default function SimulationTable({ resultContent }) {
  const dispatch = useDispatch();
  const { title, scenario, data } = resultContent.jsonMatrix;

  const [isLandscape, setIsLandscape] = useState(
    typeof window !== 'undefined'
      ? window.matchMedia('(orientation: landscape)').matches
      : false,
  );

  useEffect(() => {
    const mm = window.matchMedia('(orientation: landscape)');
    const onChange = () => setIsLandscape(mm.matches);
    onChange();
    mm.addEventListener?.('change', onChange);
    window.addEventListener('resize', onChange);
    window.addEventListener('orientationchange', onChange);
    return () => {
      mm.removeEventListener?.('change', onChange);
      window.removeEventListener('resize', onChange);
      window.removeEventListener('orientationchange', onChange);
    };
  }, []);

  useEffect(() => {
    dispatch(setChartTitle(title));
  }, [title]);

  if (!resultContent?.jsonMatrix || !resultContent.jsonMatrix.data) {
    return (
      <div className="chart-content-center">
        <p>No simulation data available</p>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="chart-content-center">
        <p>No rows to display</p>
      </div>
    );
  }

  const rows = data.map((row, rowIndex) => {
    const transformedRow = { id: rowIndex + 1 };
    Object.keys(row).forEach(columnName => {
      const field = getFieldName(columnName);
      transformedRow[field] = row[columnName];
    });
    return transformedRow;
  });

  const columns = Object.keys(data[0]).map(columnName => {
    const field = getFieldName(columnName);
    const type = getColumnType(columnName);

    return {
      field,
      headerName: columnName,
      width: getColumnWidth(columnName),
      type,
      renderCell:
        type === 'number'
          ? params => {
              const value = params.value;
              const color = value < 0 ? 'red' : value > 0 ? 'green' : 'black';
              return <span style={{ color }}>{value}</span>;
            }
          : undefined,
    };
  });

  return (
    <div className="chart-content-center">
      <div
        className={`table-wrapper ${
          isLandscape ? 'is-landscape' : 'is-portrait'
        }`}
      >
        <TableComponent rows={rows} columns={columns} />
        {scenario && <p>{scenario}</p>}
      </div>
    </div>
  );
}

function getFieldName(columnName) {
  return columnName.toLowerCase().replace(/[^a-z0-9]/g, '');
}

function getColumnWidth(columnName) {
  const widthMap = {
    No: 60,
    'Inv. Name': 200,
    'Allocation (%)': 130,
    Inception: 100,
    Strategy: 200,
    'Min Performance (%)': 140,
    'Med Performance (%)': 140,
    'Max Performance (%)': 140,
    Year: 80,
    GDP: 120,
    Inflation: 120,
    Employment: 120,
  };
  return widthMap[columnName] || 120;
}

function getColumnType(columnName) {
  const numericColumns = [
    'GDP',
    'Inflation',
    'Employment',
    'Growth',
    'Value',
    'Allocation (%)',
    'Min Performance (%)',
    'Med Performance (%)',
    'Max Performance (%)',
  ];
  return numericColumns.includes(columnName) ? 'number' : 'string';
}
